<template>

  <card
      :loading="false"
      :maxWidth="'auto'"
      :width="'100%'"
  >
    <div slot="title">Системы организма</div>

    <el-table
        style="width: 100%"
        class="zebra-table"
        :data="humanSystemHealth"
    >
      <el-table-column
          prop="human_system_type.title"
          label="Название системы">
      </el-table-column>
      <el-table-column
          class="zebra-table__value"
          width="200"
          label="Автоматическая оценка">
        <template scope="scope">
          <div class="badge"
               :style="{'background': scope.row.set_by_doctor ? scope.row.last_auto_value_color : scope.row.color}">

            {{ scope.row.set_by_doctor ? scope.row.last_auto_value : scope.row.value }}
          </div>
        </template>
      </el-table-column>
      <el-table-column
          width="110"
          label="Моя оценка">
        <template scope="scope">
          <div class="zebra-table__field"
               :style="{
                 'background': colorField[scope.row.id] ? colorField[scope.row.id] : scope.row.set_by_doctor ? scope.row.color : '',
                 'border-color':  colorField[scope.row.id] ? colorField[scope.row.id] : scope.row.set_by_doctor ? scope.row.color : '#ccc'
               }"
          >
            <el-input-number v-model="scope.row.hendValue"
                             v-loading="loading && loadingIndex === scope.row.id"
                             @change="sendHandleValue(scope.row, $event)"
                             :controls="false"
                             :min="scope.row.human_system_type.min"
                             :max="scope.row.human_system_type.max"
                             placeholder="0"
                             class="zebra-table__input"
            />
          </div>
        </template>
      </el-table-column>
    </el-table>


  </card>
</template>
<script>
import Card from "@/components/elements/Card.vue"

export default {
  name: "OrganismSystem",
  components: {Card},
  props: {
    humanSystemHealth: {},
    user: {},
  },
  watch: {
    humanSystemHealth(array) {
      array.map(function (name) {
        if (name.set_by_doctor) name.hendValue = name.value
        return name;
      })

    }
  },
  data() {
    return {
      loading: false,
      loadingIndex: null,
      colorField: [],
      humanSystemData: []

    }
  },
  methods: {
    sendHandleValue(el, value) {
      this.loadingIndex = el.id
      this.loading = true

      this.$api.humanSystemHealth.saveSystem(
          {
            value,
            human_system_type_id: el.human_system_type.id,
            user_id: this.user.id
          }
      ).then((response) => {
        this.colorField[el.id] = response.data.color

        this.$notify.success({
          title: "Успешно",
          message: "Данные обновлены",
        })

      }).catch((res) => {
        this.colorField[el.id] = 'red'

        this.$notify.error({
          title: "Упс..",
          message: res.response.data.message,
        })
      }).finally(() => {
        this.loading = false
      })

    }
  }
}
</script>
<style scoped lang="scss">
@import "@/assets/scss/zebra-table.scss";

.badge {
  min-width: 55px;
  display: inline-block;
  padding: 5px 8px;
  border-radius: 4px;

  text-align: center;

  font-size: 12px;
  line-height: 13px;

  color: #111;
}

.zebra-table {
  &__field {
    border: 1px solid transparent;
    border-radius: 4px;
    width: 55px;

  }

  &__input {
    width: 53px;
    border: none !important;
    padding: 0 !important;


    /deep/ input {
      text-align: center !important;
      border: none !important;

      padding: 0;

      background: transparent;

      font-weight: 500 !important;
      font-size: 12px !important;
      height: 24px;

    }

    /deep/ .el-loading-spinner {

      margin-top: -15px !important;

      .circular {
        height: 30px !important;
        width: 30px !important;
      }
    }

    /deep/ .el-loading-mask {
      width: 53px !important;
      border-radius: 4px;
    }


  }
}
</style>
